import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { Observable } from 'rxjs';

@Pipe({
    name: 'planingEventCategoryColor',
    standalone: false
})
export class PlaningEventCategoryColorPipe implements PipeTransform {

  constructor(private themeService: ThemeService) {
  }

  transform(value: string): Observable<string> {
    return this.themeService.getTheme().pipe(
      map(() => this.getColorSynchronously(value))
    );
  }

  public getColorSynchronously(value: string): string {
    switch (value) {
      case 'Environmental':
        return this.themeService.getColor('--event-category-environmental');
      case 'Grid Limitation':
        return this.themeService.getColor('--event-category-grid-lim');
      case 'Maintenance':
        return this.themeService.getColor('--event-category-maintainance');
      case 'Repairs':
        return this.themeService.getColor('--event-category-repairs');
      case 'Inspection':
        return this.themeService.getColor('--event-category-inspection');
      default:
        return 'transparent';
    }
  }

}
